import { useEffect, useState } from "react";
import {
  FaSort,
  FaDownload,
  FaUpload,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import { FaArrowLeft, FaPlus, FaPencilAlt } from "react-icons/fa";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

import "./others.css";
import AddNewServiceModal from "./AddNewServiceModal";
import Modal from "../../modals/Modal";
import { get } from "../../../utility/fetch2";
import AddFundsToWallet from "./AddFundsToWallet";
// import AddNewServiceModal from "./AddNewServiceModal";
// import ScheduleUpdateModal from "../modals/ScheduleUpdateModal";
// import DeclineModal from "../modals/DeclineModal";
// import { get, post } from "../../utility/fetchWeb";
// import notification from "../../utility/notification";

const generateDateRange = () => {
  const today = new Date();
  const dates = [];

  // Start from 7 days ago
  for (let i = -7; i <= 7; i++) {
    const date = new Date(today);
    date.setDate(today.getDate() + i);

    dates.push({
      date: date.getDate(),
      day: date.toLocaleDateString("en-US", { weekday: "short" }).toUpperCase(),
      fullDate: date, // Keep full date for comparison
    });
  }

  return dates;
};

const MedicalDashboard = ({ data }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  // Initialize selectedDate with today's date
  const [selectedDate, setSelectedDate] = useState(new Date().getDate());
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [isModalOpenWallet, setIsModalOpenWallet] = useState(false);
  const [showTransactions, setshowTransactions] = useState(false);
  const [transactionsData, setTransactionsData] = useState([]);
  const [wallets, setWallets] = useState();
  const [toFund, settoFund] = useState(null);
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [showTrialExpiryModal, setShowTrialExpiryModal] = useState(false);
  const doctorId = sessionStorage.getItem("userId");
  const userInfo = JSON.parse(localStorage.getItem("USER_INFO"));

  useEffect(() => {
    getTransactions();
    getWallets();

    // Show trial expiry modal on component mount
    // setShowTrialExpiryModal(true);
  }, []);

  // wallet/user/234?pageNumber=1&pageSize=10

  const getWallets = async (e) => {
    // e.preventDefault();

    try {
      const response = await get(
        `/wallet/user/${userInfo.userId}?pageNumber=1&pageSize=10`
      );

      console.log(response);
      console.log(response?.items[0]);
      setWallets(response?.items[0]);
    } catch (error) {
      console.error("Error fetching laboratories:", error);
      // setLabs([]);
    }
  };
  const getTransactions = async (e) => {
    // e.preventDefault();

    try {
      const response = await get(`/transaction/user/${userInfo.userId}`);

      console.log(response);
      setTransactionsData(response?.items);
      // Filter for laboratory providers and format for react-select
      // const laboratoryProviders = response.resultList
      //   .filter((lab) => lab.healthCareProviderCategory?.name === "Laboratory")
      //   .map((lab) => ({
      //     value: lab.id,
      //     label: lab.name,
      //     location: lab.location,
      //     phone: lab.phone,
      //     email: lab.email,
      //   }));
      // setLabs(laboratoryProviders);
    } catch (error) {
      console.error("Error fetching laboratories:", error);
      // setLabs([]);
    }

    // Clear form fields
    // setServiceName("");
    // setAmount("");
    // setAdditionalNote("");

    // onClose(); // Close the modal after submission
  };
  //  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = (type) => {
    setIsModalOpenWallet(true);
    settoFund(type);
  };

  const handleCloseModal = () => {
    setIsModalOpenWallet(false);
  };

  const handleCloseModalWallet = () => {
    setIsModalOpenWallet(false);
  };

  // Generate dynamic dates
  const dates = generateDateRange();

  // Sample appointment data based on your structure

  return (
    <div className="w-100  others">
      {/* Main Content */}
      {!showTransactions && (
        <div className="main-content">
          {/* Header */}
          <div className="app-container">
            {/* Header Section */}
            <div className="header">
              <h1 className="header-title">Funds Management</h1>
              <div className="header-actions">
                <span
                  onClick={() => setshowTransactions((prev) => !prev)}
                  className="manage-fee cursor-pointer"
                >
                  Manage Service Fee
                </span>
                <button
                  onClick={() => setShowSubscriptionModal(true)}
                  className="subscription-btn"
                  style={{
                    backgroundColor: "#007bff",
                    color: "white",
                    border: "none",
                    padding: "8px 16px",
                    borderRadius: "5px",
                    cursor: "pointer",
                    marginRight: "10px",
                  }}
                >
                  Manage Subscription
                </button>
                <button
                  onClick={() => handleOpenModal(true)}
                  className="fund-wallet-btn"
                >
                  Fund Wallet
                </button>
                <button
                  onClick={() => handleOpenModal(false)}
                  className="withdraw-btn"
                >
                  Withdraw
                </button>
              </div>
            </div>

            <div className="flex" style={{ gap: "10px" }}>
              <WalletCard title={"Wallet Balance"} amount={wallets?.balance} />
              <WalletCard
                amount={0}
                title={"Earnings from Upcoming Bookings"}
              />
              <WalletCard amount={0} title={"Earnings from current Patients"} />
              <WalletCard amount={0} title={"Expected Earnings from HMO"} />
              {/* <WalletCard />
              <WalletCard />
              <WalletCard />
              <WalletCard /> */}
            </div>
            {/* hahahahahahahah */}

            {/* <AddNewServiceModal/> */}

            <TransactionTable data={transactionsData} />

            {/* You can add more content here if needed for the full page */}
          </div>

          {/* Doctor Info */}
        </div>
      )}
      {showTransactions && (
        <div className="main-content">
          <ListOfServices
            setshowTransactions={setshowTransactions}
            showTransactions={showTransactions}
          />
        </div>
      )}

      <Modal isOpen={isModalOpenWallet} onClose={handleCloseModalWallet}>
        <AddFundsToWallet
          toFund={toFund}
          wallets={wallets?.id}
          onClose={handleCloseModalWallet}
          // onSubmit={handleFormSubmit}
        />
      </Modal>

      {/* Subscription Management - Full Screen Overlay */}
      {showSubscriptionModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 10000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
          }}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setShowSubscriptionModal(false);
            }
          }}
        >
          <div
            style={{
              position: "relative",
              maxWidth: "1400px",
              width: "95vw",
              maxHeight: "90vh",
              overflowY: "auto",
              backgroundColor: "white",
              borderRadius: "16px",
              boxShadow: "0 25px 50px rgba(0,0,0,0.15)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={() => setShowSubscriptionModal(false)}
              style={{
                position: "absolute",
                top: "20px",
                right: "20px",
                background: "rgba(255, 255, 255, 0.9)",
                border: "2px solid #e9ecef",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "20px",
                color: "#6c757d",
                zIndex: 10001,
                transition: "all 0.3s ease",
              }}
            >
              ×
            </button>

            <SubscriptionManagement
              onClose={() => setShowSubscriptionModal(false)}
            />
          </div>
        </div>
      )}

      {/* Schedule Management Drawer */}

      {/* Trial Expiry Modal */}
      <Dialog
        open={showTrialExpiryModal}
        onClose={() => setShowTrialExpiryModal(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            backgroundColor: "#fff3cd",
            border: "2px solid #ffc107",
            borderRadius: "12px",
            boxShadow: "0 8px 32px rgba(255, 193, 7, 0.3)",
          },
        }}
      >
        <DialogTitle
          style={{
            backgroundColor: "#ffc107",
            color: "#212529",
            textAlign: "center",
            fontWeight: "bold",
            padding: "20px",
            fontSize: "1.25rem",
          }}
        >
          ⚠️ Trial Period Expiring Soon!
        </DialogTitle>
        <DialogContent style={{ padding: "24px", textAlign: "center" }}>
          <Typography
            variant="h6"
            style={{
              marginBottom: "16px",
              color: "#495057",
              fontWeight: "bold",
            }}
          >
            Your free trial will expire in 30 days
          </Typography>
          <Typography
            variant="body1"
            style={{ marginBottom: "16px", color: "#6c757d" }}
          >
            Don't lose access to your medical practice management tools. Upgrade
            now to continue enjoying all features without interruption.
          </Typography>
          <Typography
            variant="body2"
            style={{ color: "#6c757d", marginBottom: "8px" }}
          >
            Unlimited patient records
          </Typography>
          <Typography
            variant="body2"
            style={{ color: "#6c757d", marginBottom: "8px" }}
          >
            Advanced appointment scheduling
          </Typography>
          <Typography
            variant="body2"
            style={{ color: "#6c757d", marginBottom: "8px" }}
          >
            Prescription management
          </Typography>
          <Typography
            variant="body2"
            style={{ color: "#6c757d", marginBottom: "16px" }}
          >
            Comprehensive reporting & analytics
          </Typography>
        </DialogContent>
        <DialogActions
          style={{ justifyContent: "center", padding: "16px 24px 24px" }}
        >
          <Button
            onClick={() => {
              setShowTrialExpiryModal(false);
              setShowSubscriptionModal(true);
            }}
            variant="contained"
            style={{
              backgroundColor: "#28a745",
              color: "white",
              marginRight: "12px",
              padding: "10px 24px",
              fontWeight: "bold",
            }}
          >
            Upgrade Now
          </Button>
          <Button
            onClick={() => setShowTrialExpiryModal(false)}
            variant="outlined"
            style={{
              borderColor: "#6c757d",
              color: "#6c757d",
              padding: "10px 24px",
            }}
          >
            Remind Me Later
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default MedicalDashboard;

const WalletCard = ({ amount, title }) => {
  const cardStyle = {
    background: "#fff",
    borderRadius: "8px",
    padding: "20px",
    width: "200px",
    boxShadow: "0 1px 4px rgba(0, 0, 0, 0.05)",
    position: "relative",
    fontFamily: "Arial, sans-serif",
  };

  const iconWrapperStyle = {
    background: "#e9f6ee",
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "12px",
  };

  const iconStyle = {
    fontSize: "18px",
    color: "green",
  };

  const labelStyle = {
    fontSize: "13px",
    color: "#555",
    marginBottom: "6px",
  };

  const amountStyle = {
    fontSize: "18px",
    fontWeight: "bold",
    color: "#333",
  };

  const moreOptionsStyle = {
    position: "absolute",
    top: "10px",
    right: "10px",
    fontSize: "18px",
    color: "#ccc",
    cursor: "pointer",
  };

  return (
    <div style={cardStyle}>
      <div style={moreOptionsStyle}>⋯</div>
      <div style={iconWrapperStyle}>
        <span style={iconStyle}>💳</span>
      </div>
      <div style={labelStyle}>{title}</div>
      <div style={amountStyle}>₦{amount}</div>
    </div>
  );
};

function TransactionTable({ setshowTransactions, data }) {
  // const transactions = [
  //   {
  //     id: 1,
  //     description: "Consultation fee from Goodness Obaleye",
  //     icon: <FaDownload style={{ color: "#28a745", marginRight: "8px" }} />,
  //     transactionNo: "92187102965",
  //     amount: "₦170,150.00",
  //     type: "Credit",
  //     dateTime: "Today, 10:30 PM",
  //     status: "Successful",
  //     statusColor: "#d4edda", // Light green
  //     statusText: "#155724", // Dark green
  //   },
  //   {
  //     id: 2,
  //     description: "Transfer to GTBank personal account",
  //     icon: <FaUpload style={{ color: "#dc3545", marginRight: "8px" }} />,
  //     transactionNo: "92187102965",
  //     amount: "₦50,500.17",
  //     type: "Debit",
  //     dateTime: "Today, 8:45 PM",
  //     status: "In Progress",
  //     statusColor: "#fff3cd", // Light orange
  //     statusText: "#856404", // Dark orange
  //   },
  //   {
  //     id: 3,
  //     description: "Monthly ConnectedHealthPro Subscription Payment",
  //     icon: <FaDownload style={{ color: "#28a745", marginRight: "8px" }} />,
  //     transactionNo: "92187102965",
  //     amount: "₦170,150.00",
  //     type: "Credit",
  //     dateTime: "Yesterday, 10:30 PM",
  //     status: "Successful",
  //     statusColor: "#d4edda",
  //     statusText: "#155724",
  //   },
  //   {
  //     id: 4,
  //     description: "Consultation fee from Matthew Ogbomnaya",
  //     icon: <FaDownload style={{ color: "#28a745", marginRight: "8px" }} />,
  //     transactionNo: "92187102965",
  //     amount: "₦170,150.00",
  //     type: "Credit",
  //     dateTime: "Yesterday, 10:30 PM",
  //     status: "Successful",
  //     statusColor: "#d4edda",
  //     statusText: "#155724",
  //   },
  //   {
  //     id: 5,
  //     description: "Commission percentage from Bayne Pharmacy",
  //     icon: <FaDownload style={{ color: "#28a745", marginRight: "8px" }} />,
  //     transactionNo: "92187102965",
  //     amount: "₦170,150.00",
  //     type: "Credit",
  //     dateTime: "March 28, 2025, 10:30 PM",
  //     status: "Successful",
  //     statusColor: "#d4edda",
  //     statusText: "#155724",
  //   },
  //   {
  //     id: 6,
  //     description: "Commission percentage for patient referral",
  //     icon: <FaDownload style={{ color: "#28a745", marginRight: "8px" }} />,
  //     transactionNo: "92187102965",
  //     amount: "₦170,150.00",
  //     type: "Credit",
  //     dateTime: "March 25, 2025, 10:30 PM",
  //     status: "Successful",
  //     statusColor: "#d4edda",
  //     statusText: "#155724",
  //   },
  //   {
  //     id: 7,
  //     description: "Transfer to GTBank personal account",
  //     icon: <FaUpload style={{ color: "#dc3545", marginRight: "8px" }} />,
  //     transactionNo: "92187102965",
  //     amount: "₦50,500.17",
  //     type: "Debit",
  //     dateTime: "March 25, 2025, 8:45 PM",
  //     status: "Canceled",
  //     statusColor: "#f8d7da", // Light red
  //     statusText: "#721c24", // Dark red
  //   },
  // ];
  console.log(data);
  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "#f8f8f8",
        minHeight: "100vh",
        boxSizing: "border-box",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "8px",
          boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
          overflow: "hidden",
        }}
      >
        {/* Top Bar */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "15px 20px",
            borderBottom: "1px solid #eee",
          }}
        >
          <h2
            style={{
              fontSize: "20px",
              fontWeight: "bold",
              color: "#333",
              margin: 0,
            }}
          >
            All Transactions
          </h2>
          <button
            style={{
              background: "none",
              border: "1px solid #ddd",
              borderRadius: "5px",
              padding: "8px 15px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              color: "#555",
              fontWeight: "bold",
              fontSize: "14px",
              outline: "none",
              // No hover effect with inline style directly on element
            }}
          >
            <FaSort style={{ fontSize: "14px" }} /> Sort By
          </button>
        </div>

        {/* Transaction Table */}
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead
              style={{
                backgroundColor: "#e9ffe9",
                borderBottom: "1px solid #d4edda",
              }}
            >
              <tr style={{ textAlign: "left" }}>
                <th
                  style={{
                    padding: "15px 20px",
                    color: "#28a745",
                    fontSize: "14px",
                    fontWeight: "bold",
                    minWidth: "200px",
                  }}
                >
                  Transaction Description
                </th>
                <th
                  style={{
                    padding: "15px 20px",
                    color: "#28a745",
                    fontSize: "14px",
                    fontWeight: "bold",
                    minWidth: "120px",
                  }}
                >
                  Transaction no
                </th>
                <th
                  style={{
                    padding: "15px 20px",
                    color: "#28a745",
                    fontSize: "14px",
                    fontWeight: "bold",
                    minWidth: "100px",
                  }}
                >
                  Amount
                </th>
                <th
                  style={{
                    padding: "15px 20px",
                    color: "#28a745",
                    fontSize: "14px",
                    fontWeight: "bold",
                    minWidth: "80px",
                  }}
                >
                  Type
                </th>
                <th
                  style={{
                    padding: "15px 20px",
                    color: "#28a745",
                    fontSize: "14px",
                    fontWeight: "bold",
                    minWidth: "150px",
                  }}
                >
                  Date - Time
                </th>
                <th
                  style={{
                    padding: "15px 20px",
                    color: "#28a745",
                    fontSize: "14px",
                    fontWeight: "bold",
                    minWidth: "100px",
                  }}
                >
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              {data?.map((transaction, index) => (
                <tr
                  key={transaction.id}
                  style={{
                    borderBottom: "1px solid #eee",
                    backgroundColor: index % 2 === 0 ? "#fff" : "#fcfcfc",
                  }}
                >
                  <td
                    style={{
                      padding: "15px 20px",
                      fontSize: "14px",
                      color: "#333",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {transaction.icon} {transaction.description}
                  </td>
                  <td
                    style={{
                      padding: "15px 20px",
                      fontSize: "14px",
                      color: "#555",
                    }}
                  >
                    {transaction.reference}
                  </td>
                  <td
                    style={{
                      padding: "15px 20px",
                      fontSize: "14px",
                      color: "#333",
                      fontWeight: "bold",
                    }}
                  >
                    {transaction.amount}
                  </td>
                  <td
                    style={{
                      padding: "15px 20px",
                      fontSize: "14px",
                      color: "#555",
                    }}
                  >
                    {transaction.transactionType}
                  </td>
                  <td
                    style={{
                      padding: "15px 20px",
                      fontSize: "14px",
                      color: "#555",
                    }}
                  >
                    {transaction.dateModified}
                  </td>
                  <td style={{ padding: "15px 20px", fontSize: "13px" }}>
                    <span
                      style={{
                        backgroundColor: transaction.statusColor,
                        color: transaction.statusText,
                        padding: "5px 10px",
                        borderRadius: "5px",
                        fontWeight: "bold",
                        display: "inline-block", // Ensure padding applies correctly
                      }}
                    >
                      {transaction.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            padding: "20px",
            borderTop: "1px solid #eee",
            gap: "8px",
          }}
        >
          <FaChevronLeft
            style={{ color: "#aaa", cursor: "pointer", fontSize: "14px" }}
          />
          {[1, 2, 3, "", 10, 11].map((page, index) => (
            <span
              key={index}
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: "30px",
                height: "30px",
                borderRadius: "5px",
                backgroundColor: page === 1 ? "#28a745" : "transparent",
                color: page === 1 ? "white" : "#555",
                fontWeight: "bold",
                cursor: "pointer",
                fontSize: "14px",
                border: page === 1 ? "none" : "1px solid #ddd",
              }}
            >
              {page === "" ? "..." : page}
            </span>
          ))}
          <FaChevronRight
            style={{ color: "#333", cursor: "pointer", fontSize: "14px" }}
          />
        </div>
      </div>
    </div>
  );
}

function ListOfServices({ setshowTransactions }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [services, setservices] = useState([]);

  useEffect(() => {
    fetchMedications();
  }, []);

  const fetchMedications = async () => {
    // if (!selectedLab?.value) return;

    try {
      const response = await get(`/costsetup`);

      console.log(response);
      setservices(response);
      // const data = response?.data?.recordList;

      // const options = data?.map((med) => ({
      //   value: med?.id,
      //   label: med?.productName,
      //   cost: med?.sellingPrice,
      //   manufacturer: med?.manufacturer,
      //   isComposite: med?.isComposite || false,
      // }));

      // setMedicationOptions(options);
      // setSelectedMedication(null);
    } catch (error) {
      console.log(error);
      // setMedicationOptions([]);
    }
  };
  // Mock data for the services table
  // const services = [
  //   {
  //     id: 1,
  //     name: "Consultation Service",
  //     amount: "₦170,150.00",
  //     remarks: "It is a long established fact that a reader will be distracted",
  //   },
  //   {
  //     id: 2,
  //     name: "Admission Service - General Medicine",
  //     amount: "₦50,500.17",
  //     remarks: "Many desktop publishing packages and web page editors.",
  //   },
  //   {
  //     id: 3,
  //     name: "Commission for Referral to Medical Laboratory",
  //     amount: "₦170,150.00",
  //     remarks: "Various versions have evolved over the years sometimes",
  //   },
  //   {
  //     id: 4,
  //     name: "Commission for Referral to Pharmacy",
  //     amount: "₦170,150.00",
  //     remarks: "All the Lorem Ipsum generators on the Internet predefined.",
  //   },
  //   {
  //     id: 5,
  //     name: "Commission for Referral to Other Doctors",
  //     amount: "₦170,150.00",
  //     remarks: "This book is a treatise on the theory of ethics very popular.",
  //   },
  //   {
  //     id: 6,
  //     name: "Commission for Referral to Other Clinic/Hospital",
  //     amount: "₦170,150.00",
  //     remarks: "Richard McClintock, a Latin professor at Hampden-Sydney.",
  //   },
  //   {
  //     id: 7,
  //     name: "Transfer to GTBank personal account",
  //     amount: "₦50,500.17",
  //     remarks: "The standard chunk of Lorem Ipsum used since the 1500s.",
  //   },
  // ];

  const handleOpenModal = (type) => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleFormSubmit = (formData) => {
    console.log("Form Submitted!", formData);
    // Here you would typically send this data to an API
    // e.g., axios.post('/api/services', formData);
    alert(
      `Service "${formData.serviceName}" with amount $${formData.amount} added!`
    );
  };

  return (
    <div className="msf-page__container">
      {/* Header Section */}
      <div className="msf-header">
        <div className="msf-header__left">
          <FaArrowLeft
            onClick={() => {
              setshowTransactions((prev) => !prev);
            }}
            className=""
          />
          <h3 className="msf-header__title">Manage Service Fee</h3>
        </div>
        <button onClick={handleOpenModal} className="msf-header__add-button">
          <FaPlus className="msf-header__add-icon" />
          Add New Service
        </button>
      </div>

      <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
        <AddNewServiceModal
          onClose={handleCloseModal}
          onSubmit={handleFormSubmit}
        />
      </Modal>

      {/* Main Content Area */}
      <div className="msf-content__area">
        <h2 className="msf-content__list-title">List of Services</h2>

        {/* Services Table */}
        <div className="msf-table__wrapper">
          <table className="msf-table">
            <thead className="msf-table__head">
              <tr className="msf-table__row-header">
                <th className="msf-table__header-cell">Service Name</th>
                <th className="msf-table__header-cell">Amount</th>
                <th className="msf-table__header-cell msf-table__header-cell--remarks">
                  Remarks
                </th>
                <th className="msf-table__header-cell msf-table__header-cell--action"></th>{" "}
                {/* Action column header */}
              </tr>
            </thead>
            <tbody className="msf-table__body">
              {services?.map((service) => (
                <tr key={service.id} className="msf-table__row">
                  <td className="msf-table__cell">{service.service}</td>
                  <td className="msf-table__cell msf-table__cell--amount">
                    {service.amount}
                  </td>
                  <td className="msf-table__cell msf-table__cell--remarks">
                    {service.comment}
                  </td>
                  <td className="msf-table__cell msf-table__cell--action">
                    <FaPencilAlt className="msf-table__edit-icon" />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

// Subscription Management Component
function SubscriptionManagement({ onClose }) {
  const [subscriptionData, setSubscriptionData] = useState({
    currentPlan: "Basic Plan",
    status: "inactive",
    nextBillingDate: "",
    amount: "",
    features: [
      "Up to 100 patients",
      "Basic appointment scheduling",
      "Standard reporting",
      "Email support",
    ],
  });

  const [selectedPlan, setSelectedPlan] = useState("basic");
  const [paymentMethod, setPaymentMethod] = useState("card");
  const [showPaymentForm, setShowPaymentForm] = useState(false);

  // Brand colors
  const brandColors = {
    primary: "#4B8AFF",
    secondary: "#28a745",
    accent: "#6c5ce7",
    warning: "#ffa726",
    danger: "#ef5350",
    light: "#f8f9fa",
    dark: "#343a40",
    background: "#ffffff",
    border: "#e9ecef",
    textPrimary: "#212529",
    textSecondary: "#6c757d",
  };

  const subscriptionPlans = [
    {
      id: "basic",
      name: "Basic Plan",
      price: "300,000",
      duration: "per year",
      color: brandColors.secondary,
      features: [
        "Access to unlimited patient records",
        "Appointment scheduling and management",
        "Administrative task automation",
        "Email support only",
      ],
    },
    {
      id: "advanced",
      name: "Advanced Plan",
      price: "600,000",
      duration: "per year",
      color: brandColors.primary,
      features: [
        "Access to unlimited patient records",
        "Appointment scheduling and management",
        "Administrative task automation",
        "Email and contact center support",
        "Dedicated staff support for enhanced service efficiency",
      ],
    },
    {
      id: "enterprise",
      name: "Enterprise Plan",
      price: "3,000,000",
      duration: "per year (inclusive of ₦100,000/month for on-premise support)",
      color: brandColors.accent,
      features: [
        "Access to unlimited patient records",
        "Appointment scheduling and management",
        "Administrative task automation",
        "Email and contact center assistance",
        "24/7 dedicated support availability",
        "On-premise or resident technical support staff",
      ],
    },
  ];

  const handlePlanSelect = (planId) => {
    setSelectedPlan(planId);
    setShowPaymentForm(true); // Immediately switch to payment form
  };

  const handleUpgrade = () => {
    setShowPaymentForm(true);
  };

  const handlePayment = (e) => {
    e.preventDefault();
    // Handle payment processing here
    alert(
      "Payment processed successfully! Your subscription has been updated."
    );
    onClose();
  };

  return (
    <div
      style={{
        // border: `2px solid red`,
        minWidth: "",
        // width: "95vw",
        maxHeight: "90vh",
        overflowY: "auto",
        padding: "0",
        borderRadius: "16px",
        boxShadow: "0 25px 50px rgba(0,0,0,0.15)",
        background: brandColors.background,
      }}
    >
      {/* Header with brand gradient */}
      <div
        style={{
          background: `linear-gradient(135deg, ${brandColors.primary} 0%, ${brandColors.accent} 100%)`,
          color: "white",
          padding: "32px 40px",
          borderRadius: "16px 16px 0 0",
          textAlign: "center",
        }}
      >
        <h2
          style={{
            margin: "0 0 12px 0",
            fontSize: "32px",
            fontWeight: "bold",
          }}
        >
          Subscription Management
        </h2>
        <p
          style={{
            margin: 0,
            opacity: 0.9,
            fontSize: "18px",
          }}
        >
          Choose the perfect plan for your practice and manage billing
          preferences
        </p>
      </div>

      {!showPaymentForm ? (
        /* Main Content - Horizontal Layout */
        <div
          style={{
            display: "flex",
            minHeight: "600px",
            background: brandColors.background,
          }}
        >
          {/* Left Side - Current Status & Plans */}
          <div
            style={{
              flex: "2",
              padding: "40px",
              borderRight: `2px solid ${brandColors.border}`,
            }}
          >
            {/* Current Subscription Status - Compact Horizontal */}
            <div
              style={{
                background: `linear-gradient(135deg, ${brandColors.light} 0%, ${brandColors.background} 100%)`,
                border: `2px solid ${brandColors.border}`,
                borderRadius: "16px",
                padding: "24px",
                marginBottom: "32px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
              }}
            >
              <h3
                style={{
                  margin: "0 0 20px 0",
                  color: brandColors.textPrimary,
                  fontSize: "22px",
                  textAlign: "center",
                  fontWeight: "600",
                }}
              >
                Current Subscription Status
              </h3>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "20px",
                  flexWrap: "wrap",
                }}
              >
                <div
                  style={{ textAlign: "center", flex: 1, minWidth: "120px" }}
                >
                  <p
                    style={{
                      margin: "0 0 8px 0",
                      fontSize: "11px",
                      color: brandColors.textSecondary,
                      fontWeight: "bold",
                      letterSpacing: "1.5px",
                      textTransform: "uppercase",
                    }}
                  >
                    Current Plan
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "16px",
                      fontWeight: "bold",
                      color: brandColors.secondary,
                    }}
                  >
                    {subscriptionData.currentPlan}
                  </p>
                </div>
                <div
                  style={{ textAlign: "center", flex: 1, minWidth: "100px" }}
                >
                  <p
                    style={{
                      margin: "0 0 8px 0",
                      fontSize: "11px",
                      color: brandColors.textSecondary,
                      fontWeight: "bold",
                      letterSpacing: "1.5px",
                      textTransform: "uppercase",
                    }}
                  >
                    Status
                  </p>
                  <span
                    style={{
                      display: "inline-block",
                      padding: "6px 16px",
                      backgroundColor: `${brandColors.secondary}20`,
                      color: brandColors.secondary,
                      borderRadius: "25px",
                      fontSize: "12px",
                      fontWeight: "bold",
                      border: `2px solid ${brandColors.secondary}`,
                    }}
                  >
                    {subscriptionData.status}
                  </span>
                </div>
                <div
                  style={{ textAlign: "center", flex: 1, minWidth: "120px" }}
                >
                  <p
                    style={{
                      margin: "0 0 8px 0",
                      fontSize: "11px",
                      color: brandColors.textSecondary,
                      fontWeight: "bold",
                      letterSpacing: "1.5px",
                      textTransform: "uppercase",
                    }}
                  >
                    Next Billing
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "16px",
                      fontWeight: "bold",
                      color: brandColors.textPrimary,
                    }}
                  >
                    {subscriptionData.nextBillingDate}
                  </p>
                </div>
                <div
                  style={{ textAlign: "center", flex: 1, minWidth: "100px" }}
                >
                  <p
                    style={{
                      margin: "0 0 8px 0",
                      fontSize: "11px",
                      color: brandColors.textSecondary,
                      fontWeight: "bold",
                      letterSpacing: "1.5px",
                      textTransform: "uppercase",
                    }}
                  >
                    Amount
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "20px",
                      fontWeight: "bold",
                      color: brandColors.primary,
                    }}
                  >
                    {subscriptionData.amount}
                  </p>
                </div>
              </div>
            </div>

            {/* Available Plans - Horizontal Cards */}
            <h3
              style={{
                margin: "0 0 24px 0",
                color: brandColors.textPrimary,
                fontSize: "24px",
                textAlign: "center",
                fontWeight: "600",
              }}
            >
              Choose Your Plan
            </h3>
            <div
              style={{
                display: "flex",
                gap: "20px",
                marginBottom: "20px",
                overflowX: "auto",
                paddingBottom: "10px",
              }}
            >
              {subscriptionPlans.map((plan) => (
                <div
                  key={plan.id}
                  onClick={() => handlePlanSelect(plan.id)}
                  style={{
                    border: "2px solid red",
                    minWidth: "px",
                    flex: "1",
                    border:
                      selectedPlan === plan.id
                        ? `3px solid ${plan.color}`
                        : `2px solid ${brandColors.border}`,
                    borderRadius: "20px",
                    padding: "0",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    backgroundColor: brandColors.background,
                    boxShadow:
                      selectedPlan === plan.id
                        ? `0 12px 30px ${plan.color}25`
                        : "0 6px 20px rgba(0,0,0,0.08)",
                    transform:
                      selectedPlan === plan.id
                        ? "translateY(-8px)"
                        : "translateY(0)",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  {/* Plan header with color accent */}
                  <div
                    style={{
                      background: `linear-gradient(135deg, ${plan.color} 0%, ${plan.color}dd 100%)`,
                      color: "white",
                      padding: "20px",
                      textAlign: "center",
                    }}
                  >
                    <h4
                      style={{
                        margin: "0 0 8px 0",
                        fontSize: "20px",
                        fontWeight: "bold",
                      }}
                    >
                      {plan.name}
                    </h4>
                    <p
                      style={{
                        margin: "0 0 12px 0",
                        fontSize: "14px",
                        opacity: 0.9,
                      }}
                    >
                      {plan.duration}
                    </p>
                    <p
                      style={{
                        margin: "0",
                        fontSize: "28px",
                        fontWeight: "bold",
                      }}
                    >
                      ₦{plan.price}
                    </p>
                  </div>

                  {/* Features list */}
                  <div style={{ padding: "24px 20px" }}>
                    <ul
                      style={{
                        margin: "0",
                        padding: "0",
                        listStyle: "none",
                        minHeight: "200px",
                      }}
                    >
                      {plan.features.map((feature, index) => (
                        <li
                          key={index}
                          style={{
                            margin: "12px 0",
                            fontSize: "14px",
                            color: brandColors.textPrimary,
                            display: "flex",
                            alignItems: "flex-start",
                            lineHeight: "1.5",
                          }}
                        >
                          <span
                            style={{
                              marginRight: "12px",
                              color: plan.color,
                              fontWeight: "bold",
                              fontSize: "16px",
                              marginTop: "2px",
                              flexShrink: 0,
                            }}
                          >
                            ✓
                          </span>
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Selection indicator */}
                  {selectedPlan === plan.id && (
                    <div
                      style={{
                        position: "absolute",
                        top: "15px",
                        right: "15px",
                        background: "white",
                        color: plan.color,
                        borderRadius: "50%",
                        width: "35px",
                        height: "35px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "18px",
                        fontWeight: "bold",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                      }}
                    >
                      ✓
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Right Side - Action Panel */}
          {/* <div
            style={{
              flex: "1",
              padding: "40px 32px",
              background: `linear-gradient(135deg, ${brandColors.light} 0%, #ffffff 100%)`,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <div
              style={{
                background: brandColors.background,
                padding: "32px",
                borderRadius: "20px",
                boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
                border: `2px solid ${brandColors.border}`,
                width: "100%",
                maxWidth: "300px",
              }}
            >
              <h4
                style={{
                  margin: "0 0 20px 0",
                  fontSize: "22px",
                  color: brandColors.textPrimary,
                  fontWeight: "600",
                }}
              >
                Selected Plan
              </h4>

              <div
                style={{
                  background: `${
                    subscriptionPlans.find((p) => p.id === selectedPlan)?.color
                  }15`,
                  padding: "20px",
                  borderRadius: "16px",
                  marginBottom: "24px",
                  border: `2px solid ${
                    subscriptionPlans.find((p) => p.id === selectedPlan)?.color
                  }30`,
                }}
              >
                <h5
                  style={{
                    margin: "0 0 8px 0",
                    fontSize: "18px",
                    color: subscriptionPlans.find((p) => p.id === selectedPlan)
                      ?.color,
                    fontWeight: "bold",
                  }}
                >
                  {subscriptionPlans.find((p) => p.id === selectedPlan)?.name}
                </h5>
                <p
                  style={{
                    margin: "0 0 12px 0",
                    fontSize: "32px",
                    fontWeight: "bold",
                    color: brandColors.textPrimary,
                  }}
                >
                  ₦
                  {parseInt(
                    subscriptionPlans.find((p) => p.id === selectedPlan)?.price
                  ).toLocaleString()}
                </p>
                <p
                  style={{
                    margin: 0,
                    fontSize: "14px",
                    color: brandColors.textSecondary,
                  }}
                >
                  {
                    subscriptionPlans.find((p) => p.id === selectedPlan)
                      ?.duration
                  }
                </p>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                }}
              >
                <button
                  onClick={handleUpgrade}
                  style={{
                    padding: "16px 32px",
                    border: "none",
                    background: `linear-gradient(135deg, ${brandColors.primary} 0%, ${brandColors.accent} 100%)`,
                    color: "white",
                    borderRadius: "12px",
                    cursor: "pointer",
                    fontSize: "16px",
                    fontWeight: "bold",
                    boxShadow: `0 6px 20px ${brandColors.primary}40`,
                    transition: "all 0.3s ease",
                    width: "100%",
                  }}
                >
                  {selectedPlan !== "basic"
                    ? "Upgrade Plan"
                    : "Continue with Current"}
                </button>

                <button
                  onClick={onClose}
                  style={{
                    padding: "14px 32px",
                    border: `2px solid ${brandColors.textSecondary}`,
                    backgroundColor: "transparent",
                    color: brandColors.textSecondary,
                    borderRadius: "12px",
                    cursor: "pointer",
                    fontSize: "16px",
                    fontWeight: "bold",
                    transition: "all 0.3s ease",
                    width: "100%",
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div> */}
        </div>
      ) : (
        // Payment Form - Horizontal Layout
        <div
          style={{
            display: "flex",
            minHeight: "600px",
            background: brandColors.background,
          }}
        >
          {/* Left Side - Payment Form */}
          <div
            style={{
              flex: "2",
              padding: "40px",
              borderRight: `2px solid ${brandColors.border}`,
            }}
          >
            <h3
              style={{
                margin: "0 0 32px 0",
                color: brandColors.textPrimary,
                fontSize: "28px",
                fontWeight: "600",
              }}
            >
              Payment Information
            </h3>

            <form onSubmit={handlePayment}>
              {/* Payment Method Selection */}
              <div style={{ marginBottom: "32px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "16px",
                    fontSize: "18px",
                    fontWeight: "bold",
                    color: brandColors.textPrimary,
                  }}
                >
                  Payment Method
                </label>
                <div style={{ display: "flex", gap: "20px" }}>
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      padding: "16px 24px",
                      border:
                        paymentMethod === "card"
                          ? `3px solid ${brandColors.primary}`
                          : `2px solid ${brandColors.border}`,
                      borderRadius: "12px",
                      backgroundColor:
                        paymentMethod === "card"
                          ? `${brandColors.primary}15`
                          : brandColors.background,
                      flex: 1,
                      fontSize: "16px",
                      fontWeight: "600",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <input
                      type="radio"
                      value="card"
                      checked={paymentMethod === "card"}
                      onChange={(e) => setPaymentMethod(e.target.value)}
                      style={{ marginRight: "12px", transform: "scale(1.2)" }}
                    />
                    💳 Credit/Debit Card
                  </label>
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      padding: "16px 24px",
                      border:
                        paymentMethod === "bank"
                          ? `3px solid ${brandColors.primary}`
                          : `2px solid ${brandColors.border}`,
                      borderRadius: "12px",
                      backgroundColor:
                        paymentMethod === "bank"
                          ? `${brandColors.primary}15`
                          : brandColors.background,
                      flex: 1,
                      fontSize: "16px",
                      fontWeight: "600",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <input
                      type="radio"
                      value="bank"
                      checked={paymentMethod === "bank"}
                      onChange={(e) => setPaymentMethod(e.target.value)}
                      style={{ marginRight: "12px", transform: "scale(1.2)" }}
                    />
                    🏦 Bank Transfer
                  </label>
                </div>
              </div>

              {paymentMethod === "card" && (
                <div
                  style={{
                    background: `${brandColors.primary}08`,
                    padding: "32px",
                    borderRadius: "16px",
                    border: `2px solid ${brandColors.primary}20`,
                  }}
                >
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: "24px",
                      marginBottom: "24px",
                    }}
                  >
                    <div>
                      <label
                        style={{
                          display: "block",
                          marginBottom: "8px",
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: brandColors.textPrimary,
                        }}
                      >
                        Card Number
                      </label>
                      <input
                        type="text"
                        placeholder="1234 5678 9012 3456"
                        style={{
                          width: "100%",
                          padding: "16px",
                          border: `2px solid ${brandColors.border}`,
                          borderRadius: "12px",
                          fontSize: "16px",
                          boxSizing: "border-box",
                          transition: "border-color 0.3s ease",
                        }}
                        required
                      />
                    </div>
                    <div>
                      <label
                        style={{
                          display: "block",
                          marginBottom: "8px",
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: brandColors.textPrimary,
                        }}
                      >
                        Cardholder Name
                      </label>
                      <input
                        type="text"
                        placeholder="John Doe"
                        style={{
                          width: "100%",
                          padding: "16px",
                          border: `2px solid ${brandColors.border}`,
                          borderRadius: "12px",
                          fontSize: "16px",
                          boxSizing: "border-box",
                        }}
                        required
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: "24px",
                    }}
                  >
                    <div>
                      <label
                        style={{
                          display: "block",
                          marginBottom: "8px",
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: brandColors.textPrimary,
                        }}
                      >
                        Expiry Date
                      </label>
                      <input
                        type="text"
                        placeholder="MM/YY"
                        style={{
                          width: "100%",
                          padding: "16px",
                          border: `2px solid ${brandColors.border}`,
                          borderRadius: "12px",
                          fontSize: "16px",
                          boxSizing: "border-box",
                        }}
                        required
                      />
                    </div>
                    <div>
                      <label
                        style={{
                          display: "block",
                          marginBottom: "8px",
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: brandColors.textPrimary,
                        }}
                      >
                        CVV
                      </label>
                      <input
                        type="text"
                        placeholder="123"
                        style={{
                          width: "100%",
                          padding: "16px",
                          border: `2px solid ${brandColors.border}`,
                          borderRadius: "12px",
                          fontSize: "16px",
                          boxSizing: "border-box",
                        }}
                        required
                      />
                    </div>
                  </div>
                </div>
              )}

              {paymentMethod === "bank" && (
                <div
                  style={{
                    background: `${brandColors.primary}15`,
                    border: `3px solid ${brandColors.primary}30`,
                    borderRadius: "16px",
                    padding: "32px",
                  }}
                >
                  <h4
                    style={{
                      margin: "0 0 20px 0",
                      color: brandColors.primary,
                      fontSize: "24px",
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    🏦 Bank Transfer Details
                  </h4>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: "16px",
                      marginBottom: "20px",
                    }}
                  >
                    <div
                      style={{
                        background: brandColors.background,
                        padding: "16px",
                        borderRadius: "12px",
                        border: `1px solid ${brandColors.border}`,
                      }}
                    >
                      <p
                        style={{
                          margin: "0 0 4px 0",
                          fontSize: "12px",
                          color: brandColors.textSecondary,
                          fontWeight: "bold",
                        }}
                      >
                        BANK NAME
                      </p>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "18px",
                          fontWeight: "bold",
                        }}
                      >
                        GTBank
                      </p>
                    </div>
                    <div
                      style={{
                        background: brandColors.background,
                        padding: "16px",
                        borderRadius: "12px",
                        border: `1px solid ${brandColors.border}`,
                      }}
                    >
                      <p
                        style={{
                          margin: "0 0 4px 0",
                          fontSize: "12px",
                          color: brandColors.textSecondary,
                          fontWeight: "bold",
                        }}
                      >
                        ACCOUNT NAME
                      </p>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "18px",
                          fontWeight: "bold",
                        }}
                      >
                        ConnectedHealthPro Ltd
                      </p>
                    </div>
                    <div
                      style={{
                        background: brandColors.background,
                        padding: "16px",
                        borderRadius: "12px",
                        border: `1px solid ${brandColors.border}`,
                        gridColumn: "1 / -1",
                      }}
                    >
                      <p
                        style={{
                          margin: "0 0 4px 0",
                          fontSize: "12px",
                          color: brandColors.textSecondary,
                          fontWeight: "bold",
                        }}
                      >
                        ACCOUNT NUMBER
                      </p>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "24px",
                          fontWeight: "bold",
                          letterSpacing: "2px",
                        }}
                      >
                        0123456789
                      </p>
                    </div>
                  </div>
                  <div
                    style={{
                      background: `${brandColors.warning}20`,
                      border: `2px solid ${brandColors.warning}40`,
                      borderRadius: "12px",
                      padding: "16px",
                    }}
                  >
                    <p
                      style={{
                        margin: 0,
                        fontSize: "14px",
                        color: brandColors.textPrimary,
                        lineHeight: "1.5",
                      }}
                    >
                      📧 <strong>Important:</strong> Please use your email
                      address as the transfer reference and send proof of
                      payment to <strong>billing@connectedhealthpro.com</strong>
                    </p>
                  </div>
                </div>
              )}
            </form>
          </div>

          {/* Right Side - Order Summary & Actions */}
          <div
            style={{
              flex: "1",
              padding: "40px 32px",
              background: `linear-gradient(135deg, ${brandColors.light} 0%, #ffffff 100%)`,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <h4
              style={{
                margin: "0 0 24px 0",
                color: brandColors.textPrimary,
                fontSize: "24px",
                fontWeight: "600",
                textAlign: "center",
              }}
            >
              Order Summary
            </h4>

            {/* Order Details */}
            <div
              style={{
                background: brandColors.background,
                border: `2px solid ${brandColors.border}`,
                borderRadius: "16px",
                padding: "24px",
                marginBottom: "24px",
                flex: 1,
              }}
            >
              <div
                style={{
                  background: `${
                    subscriptionPlans.find((p) => p.id === selectedPlan)?.color
                  }15`,
                  padding: "20px",
                  borderRadius: "12px",
                  marginBottom: "20px",
                  textAlign: "center",
                  border: `2px solid ${
                    subscriptionPlans.find((p) => p.id === selectedPlan)?.color
                  }30`,
                }}
              >
                <h5
                  style={{
                    margin: "0 0 8px 0",
                    fontSize: "20px",
                    color: subscriptionPlans.find((p) => p.id === selectedPlan)
                      ?.color,
                    fontWeight: "bold",
                  }}
                >
                  {subscriptionPlans.find((p) => p.id === selectedPlan)?.name}
                </h5>
                <p
                  style={{
                    margin: "0 0 8px 0",
                    fontSize: "14px",
                    color: brandColors.textSecondary,
                  }}
                >
                  {
                    subscriptionPlans.find((p) => p.id === selectedPlan)
                      ?.duration
                  }
                </p>
              </div>

              <div style={{ marginBottom: "16px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "12px",
                    fontSize: "16px",
                  }}
                >
                  <span>Subtotal:</span>
                  <span style={{ fontWeight: "bold" }}>
                    ₦
                    {
                      subscriptionPlans.find((p) => p.id === selectedPlan)
                        ?.price
                    }
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "16px",
                    fontSize: "14px",
                    color: brandColors.textSecondary,
                  }}
                >
                  <span>Tax (7.5%)</span>
                  {/* <span>
                    ₦
                    {(
                      (
                        subscriptionPlans.find((p) => p.id === selectedPlan)
                          ?.price
                      ) * 0.075
                    )}
                  </span> */}
                </div>
                <hr
                  style={{
                    margin: "16px 0",
                    border: "none",
                    borderTop: `3px solid ${brandColors.border}`,
                  }}
                />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontWeight: "bold",
                    fontSize: "20px",
                    color: brandColors.primary,
                  }}
                >
                  <span>Total:</span>
                  <span>
                    ₦
                    {
                      subscriptionPlans.find((p) => p.id === selectedPlan)
                        ?.price
                    }
                  </span>
                </div>
              </div>
            </div>

            {/* Action buttons */}
            <div
              style={{ display: "flex", flexDirection: "column", gap: "16px" }}
            >
              <button
                onClick={handlePayment}
                style={{
                  padding: "18px 32px",
                  border: "none",
                  background: `linear-gradient(135deg, ${brandColors.secondary} 0%, ${brandColors.primary} 100%)`,
                  color: "white",
                  borderRadius: "12px",
                  cursor: "pointer",
                  fontSize: "18px",
                  fontWeight: "bold",
                  boxShadow: `0 6px 20px ${brandColors.secondary}40`,
                  transition: "all 0.3s ease",
                  width: "100%",
                }}
              >
                💳 Complete Payment
              </button>

              <button
                type="button"
                onClick={() => setShowPaymentForm(false)}
                style={{
                  padding: "16px 32px",
                  border: `2px solid ${brandColors.textSecondary}`,
                  backgroundColor: "transparent",
                  color: brandColors.textSecondary,
                  borderRadius: "12px",
                  cursor: "pointer",
                  fontSize: "16px",
                  fontWeight: "bold",
                  width: "100%",
                }}
              >
                ← Back to Plans
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
